import { supabase } from '@/integrations/supabase/client';

const DOCUMENTS_BUCKET = 'documents';
const DOCUMENTS_PATH_REGEX = /\/storage\/v1\/object\/(?:public|sign)\/documents\/(.+)$/;

export async function resolveBankProofUrl(proofUrl?: string | null) {
  if (!proofUrl) return null;

  let storagePath = proofUrl;

  if (proofUrl.startsWith('http://') || proofUrl.startsWith('https://')) {
    try {
      const { pathname } = new URL(proofUrl);
      const match = pathname.match(DOCUMENTS_PATH_REGEX);
      if (!match) {
        return proofUrl;
      }
      storagePath = decodeURIComponent(match[1]);
    } catch (error) {
      console.error('[resolveBankProofUrl] Invalid URL:', error);
      return null;
    }
  }

  if (storagePath.startsWith(`${DOCUMENTS_BUCKET}/`)) {
    storagePath = storagePath.replace(`${DOCUMENTS_BUCKET}/`, '');
  }

  const { data, error } = await supabase.storage
    .from(DOCUMENTS_BUCKET)
    .createSignedUrl(storagePath, 60 * 60);

  if (error) {
    console.error('[resolveBankProofUrl] Failed to sign URL:', error);
    return null;
  }

  return data?.signedUrl ?? null;
}
